import React, { Component } from 'react'
import { graphql, compose } from 'react-apollo'
import { withRouter } from 'react-router-dom'

import { translate } from 'react-i18next'

import { Form, TextInput, SelectInput, BirthdayInput } from '../UI'
import Loader from '../UI/Loader'
import { NotificationManager } from 'react-notifications'

import { validateRequired } from './../../libs/validation'

import UPDATE_USER_PROFILE_QUERY from './../../graphql/UpdateUserProfile.graphql'

import USER_PROFILE_BY_USER_QUERY from './../../graphql/UserByID.graphql'

import get from 'lodash/get'


class DetailsForm extends Component {
  state = {
    routeIndex: 0,
    saving: false
  }

  handleSubmit = values => {
    this.props.validate(this.state.routeIndex, true)
    this.setState({
      saving: true
    })
    this.props
      .updateUserProfile({
        variables: {
          id: this.props.data.User.userProfile.id,
          firstName: values.firstName,
          lastName: values.lastName,
          birthDate: values.birthDate,
          gender: values.gender
        }
      })
      .then(result => {
        this.setState({
          saving: false
        })
        this.props.history.push('/activity-guide-profile/description')
      })
      .catch(err => {
        this.setState({
          saving: false
        })
        NotificationManager.error(err.message, 'Error', 5000)
      })
  }

  getGenderOptions = () => {
    return [
      {
        label: 'male',
        value: 'male'
      },
      {
        label: 'female',
        value: 'female'
      },
      {
        label: 'other',
        value: 'other'
      }
    ]
  }

  render() {
    const { t } = this.props    

    if (this.props.data.loading) {
      return <Loader showLoader={true} />
    }

    console.log("user " + this.props.user)
    
    const { firstName, lastName, birthDate, gender } = this.props.data.user[0].userProfile[0]
    const { saving } = this.state
    return (
      <div className="steps-screen__form">
        <div className="steps-screen__form-title">{t('my_details')}</div>
        <Form
          onSubmit={this.handleSubmit}
          submitBtnClassname="btn btn-lg btn-primary btn-danger"
          submitBtnName={t('main:save_continue')}
          submittingToServer={saving}
        >
          <div className="row">
            <div className="form-group clearfix">
              <div className="col-md-9">
                <TextInput
                  id="firstName"
                  placeholder="John"
                  initialValue={firstName}
                  maxChars={50}
                  validationFuncs={[validateRequired]}
                  extraClass=""
                  label={t('main:first_name')}
                />
              </div>
            </div>
            <div className="form-group clearfix">
              <div className="col-md-9">
                <TextInput
                  id="lastName"
                  placeholder="Doe"
                  initialValue={lastName}
                  maxChars={50}
                  label={t('main:last_name')}
                  validationFuncs={[validateRequired]}
                />
              </div>
            </div>
            <div className="form-group clearfix">
              <div className="col-md-9">
                <label>{t('main:birthday')}</label>
                <BirthdayInput id="birthDate" initialValue={birthDate} />
              </div>
            </div>
            <div className="form-group clearfix">
              <div className="col-md-4">
                <SelectInput
                  id="gender"
                  initialValue={gender}
                  options={this.getGenderOptions()}
                  validationFuncs={[validateRequired]}
                  label={t('main:gender')}
                  labelClass="steps-screen__form-input-label"
                  simpleValue
                  clearable={false}
                  isGroup={false}
                />
              </div>
            </div>
          </div>
        </Form>
      </div>
    )
  }
}

export default compose(
  translate('guide'),
  graphql(UPDATE_USER_PROFILE_QUERY, {
    name: 'updateUserProfile'
  }),
  graphql(USER_PROFILE_BY_USER_QUERY, {
    options: props => ({
      variables: {
        id: get(props, 'user.id', '')
      },
      options: {
        fetchPolicy: 'network-only'
      }
    })   
  }),

  withRouter
)(DetailsForm)



// WEBPACK FOOTER //
// src/components/Guide/DetailsForm.jsx